import React, { useState } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { SIDEBAR_VIEWS } from '../../../lib/constants'
import actions from './actions'
import BasemapSelectorPane from './BasemapSelectorPane'
import ChevronDown from '../../../assets/svg/Feather/ChevronDown'
import ChevronUp from '../../../assets/svg/Feather/ChevronUp'
import X from '../../../assets/svg/Feather/X'
import styles from './BasemapSelector.module.scss'
// import OverlaysPane from './OverlaysPane';

function BasemapSelector(props) {
  const [isOpen, setIsOpen] = useState(false)

  const changeBasemap = basemap => {
    props.changeBasemap(basemap)
  }

  const getActiveBasemapImg = () => {
    if (props.activeBasemapObj != null && props.activeBasemapObj.thumbnailUrl != null) return props.activeBasemapObj.thumbnailUrl

    switch (props.selectedBasemap) {
      case 'Satellite':
        return require('../../../assets/img/basemapIcons/Satellite.png')
      case 'Topographic':
        return require('../../../assets/img/basemapIcons/Topographic.png')
      case 'Hybrid':
        return require('../../../assets/img/basemapIcons/Hybrid.png')
      default:
        return ''
    }
  }

  const containerClasses = [styles.container]
  if (props.setContainerBottomLeft) {
    containerClasses.push(styles.bottomLeft)
  }

  return (
    <div className={containerClasses.join(' ')}>
      <div style={{ display: isOpen ? 'block' : 'none' }} className={styles.selectContainer}>
        <div
          onClick={() => {
            setIsOpen(false)
          }}
          className={styles.closeButton}
        >
          <X color='#ffffff' width={16} height={16} />
        </div>
        <BasemapSelectorPane
          onClickX={() => {
            setIsOpen(false)
          }}
          onChange={changeBasemap}
        />
        {/* <OverlaysPane /> */}
      </div>
      <div
        className={styles.buttonContainer}
        style={{ visibility: props.isUpdatingLocation ? 'hidden' : 'visible' }}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        <div className={styles.buttonLabel}>
          <img className={styles.basemapThumb} src={getActiveBasemapImg()} />
          <span>{props.selectedBasemap}</span>
        </div>
        <div className={styles.caret}>
          {isOpen ? <ChevronDown color='#939393' width={16} height={16} /> : <ChevronUp color='#939393' width={16} height={16} />}
        </div>
      </div>
    </div>
  )
}

BasemapSelector.propTypes = {
  activeBasemapObj: PropTypes.object,
  basemaps: PropTypes.array,
  changeBasemap: PropTypes.func,
  isUpdatingLocation: PropTypes.bool,
  selectedBasemap: PropTypes.string,
  setContainerBottomLeft: PropTypes.bool,
}

export default connect(model => {
  const { showSidebar, sidebarView } = model.app
  const { basemapMode, basemaps, isUpdatingLocation } = model.map
  const activeBasemapObj = basemaps.find(basemap => basemap.title == model.map.basemapMode)
  const selectedBasemap = basemapMode
  const setContainerBottomLeft = sidebarView.view === SIDEBAR_VIEWS.HistoricalImagery && showSidebar
  return {
    activeBasemapObj,
    basemaps,
    isUpdatingLocation,
    selectedBasemap,
    setContainerBottomLeft,
  }
}, actions)(BasemapSelector)
